<template>
    <div class="shadow-off pt-2 pb-0 pl-0 pr-0">
        <div>
            <v-card class="shadow-off">
                <div class="d-flex align-center justify-end mb-4 mt-4">
                    <v-btn data-testid="transaction-matching-config-new__add-middleware-button" color="primary" @click="$emit('addMiddlewarebox')">
                        <v-icon data-testid="transaction-matching-config-new__add-middleware-icon" class="mr-1">mdi-plus</v-icon>
                        <span>Middleware</span>
                    </v-btn>
                </div>
                <v-card-text data-testid="transaction-matching-config-new__middleware-table" class="pa-0" v-if="formatedDataMiddeleware.length > 0">
                     <lb-datatableaction :headers="middlewareHeader" :tabledata="formatedDataMiddeleware" :bulkActions="false" :selectfilter="{}" :page_details="{}">
                        <template v-slot:tbody>

                            <tr data-testid="transaction-matching-config-new__middleware-row" v-for="item in formatedDataMiddeleware" :key="item._id" class="cursor-pointer  " :class="{ 'low-opacity': item.status === false }">
                                <template v-for="header in middlewareHeader">
                                    <td v-if="header.visible && header.value !== 'action'" :key="header.value" :class="{'description-header': header.value === 'description'}" class="px-4 single-line">
                                        <div v-if="header.value ==='middlewarename'">
                                            <div data-testid="transaction-matching-config-new__middleware-file-link" @click="$nova.downloadFile((item.middlewarefile))" class="mx-2 cursor-pointer blue--text text--darken-2 caption">
                                                {{item.middlewarename}}
                                            </div>
                                        </div>
                                        <div class="" v-else-if="header.value ==='basefile'">{{gettableName(item.basefile)}}</div>
                                        <span v-else> {{item[header.value]}}</span>
                                    </td>

                                    <td v-else-if="header.value === 'action'" :key="header.value" class="px-3 single-line border-on action-data">
                                        <div class="d-flex align-center gap-1">
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn data-testid="transaction-matching-config-new__middleware-edit-button" icon small v-bind="attrs" v-on="on" @click.stop="$emit('editmiddlewarebox', item)">
                                                        <v-icon small data-testid="transaction-matching-config-new__middleware-edit-icon">mdi-pencil</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Edit</span>
                                            </v-tooltip>
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn data-testid="transaction-matching-config-new__middleware-delete-button" icon small v-bind="attrs" v-on="on" @click.stop="$emit('deletemiddlewarebox', item)">
                                                        <img src="/img/icons/tm-icons/Trash.svg" alt="Delete" data-testid="transaction-matching-config-new__middleware-delete-icon"/>
                                                    </v-btn>
                                                </template>
                                                <span>Delete</span>
                                            </v-tooltip>
                                            <v-divider vertical class="mx-1" />
                                            <v-switch
                                                data-testid="transaction-matching-config-new__middleware-status-toggle"
                                                :input-value="item.status"
                                                :false-value="false"
                                                :true-value="true"
                                                :label="item.status ? 'Enabled' : 'Disabled'"
                                                @change="$emit('changeMid', item._id, $event)"
                                                inset
                                                dense
                                                color="primary"
                                                class="mt-0 pt-0"
                                                hide-details
                                            />
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </lb-datatableaction>

                </v-card-text>
                <div data-testid="transaction-matching-config-new__middleware-empty-state" v-else class="text-center grey--text title pa-6"> No data available </div>
            </v-card>
        </div>
        <div class="mt-4">
            <v-btn data-testid="transaction-matching-config-new__step3-back-button" color="secondaryBtn" @click="$emit('back')" class="mr-1"><span>Back</span></v-btn>
            <v-btn data-testid="transaction-matching-config-new__step3-continue-button" color="primary" @click="$emit('continue')"><span>Continue</span></v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StepMiddlewareConfig',
        props: {
            formatedDataMiddeleware: Array,
            middlewareHeader: Array,
            setupList: Object,
        },
        methods: {
            gettableName(id) {
                if (this.setupList && this.setupList.file) {
                    let file = this.setupList.file.find(f => f._id === id);
                    return file ? file.name : '';
                }
                return '';
            }
        }
    }
</script>